import React from 'react';
import { CloseOutlined, KeyboardArrowDownTwoTone } from '@mui/icons-material';
import {
  Container,
  Input,
  Select,
  Options,
  Option,
  Label,
  Info,
} from './styles';

export default function TableSelectMulti({
  value,
  onChange,
  options,
  defaultValue,
}) {
  const [valueSelected, setValueSelected] = React.useState([]);
  const [toggle, setToggle] = React.useState(false);

  const onCheck = (checked, item) => {
    setToggle(!toggle);
    setValueSelected((prev) =>
      checked ? [...prev, item] : prev.filter((value) => value !== item),
    );
  };

  const itemSelect = () => {
    const temp = [];
    options.forEach(({ value, label }) => {
      valueSelected.forEach((item) => {
        if (value === item) temp.push(label);
      });
    });
    return temp;
  };

  React.useEffect(() => {
    setValueSelected(value === '' ? [] : value);
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    onChange(valueSelected);
    // eslint-disable-next-line
  }, [valueSelected]);

  return (
    <Container>
      <Select style={{ cursor: 'pointer' }} onClick={() => setToggle(!toggle)}>
        {!!valueSelected.length ? (
          valueSelected.length <= 3 ? (
            itemSelect().join(', ')
          ) : (
            `${valueSelected.length} items`
          )
        ) : (
          <Info>Pesquisar...</Info>
        )}
        {toggle ? (
          <CloseOutlined style={{ cursor: 'pointer' }} />
        ) : (
          <KeyboardArrowDownTwoTone style={{ cursor: 'pointer' }} />
        )}
      </Select>
      {toggle && (
        <Options>
          {options.map(({ label, value }, index) => (
            <Option key={index}>
              <Input
                id={value}
                type="checkbox"
                value={value}
                onChange={({ target: { checked } }) => onCheck(checked, value)}
                checked={valueSelected?.includes(value)}
                defaultChecked={!!defaultValue && defaultValue?.includes(value)}
              />
              <Label htmlFor={value}>{label}</Label>
            </Option>
          ))}
        </Options>
      )}
    </Container>
  );
}
